const getPartnerLogoUrl = (partner: string) => {
  return `https://digitalasset.intuit.com/render/content/dam/intuit/mc-fe/en_us/logos/logo-partner-${partner}.svg`;
};

const getBusinessUnitUrl = (businessUnit: string) => {
  return `https://digitalasset.intuit.com/render/content/dam/intuit/mc-fe/en_us/logos/logo-${businessUnit}.svg`;
};

type ImageConfig = {
  light: string;
  dark?: string;
};

type LogoMap = Record<string, { label: string; image: ImageConfig }>;

export const LOGO_MAP: LogoMap = {
  adobecommerce: {
    label: 'Adobe Commerce',
    image: { light: getPartnerLogoUrl('adobecommerce') },
  },
  airtable: {
    label: 'Airtable',
    image: { light: getPartnerLogoUrl('airtable') },
  },
  amazon: { label: 'Amazon', image: { light: getPartnerLogoUrl('amazon') } },
  apple: { label: 'Apple', image: { light: getPartnerLogoUrl('apple') } },
  bigcartel: {
    label: 'Big Cartel',
    image: { light: getPartnerLogoUrl('bigcartel') },
  },
  bigcommerce: {
    label: 'BigCommerce',
    image: { light: getPartnerLogoUrl('bigcommerce') },
  },
  calendly: {
    label: 'Calendly',
    image: { light: getPartnerLogoUrl('calendly') },
  },
  canva: { label: 'Canva', image: { light: getPartnerLogoUrl('canva') } },
  drupal: { label: 'Drupal', image: { light: getPartnerLogoUrl('drupal') } },
  ecwid: { label: 'Ecwid', image: { light: getPartnerLogoUrl('ecwid') } },
  eventbrite: {
    label: 'Eventbrite',
    image: { light: getPartnerLogoUrl('eventbrite') },
  },
  facebook: {
    label: 'Facebook',
    image: { light: getPartnerLogoUrl('facebook') },
  },
  firewards: {
    label: 'Firewards',
    image: { light: getPartnerLogoUrl('firewards') },
  },
  gmail: { label: 'Gmail', image: { light: getPartnerLogoUrl('gmail') } },
  google: { label: 'Google', image: { light: getPartnerLogoUrl('google') } },
  googleanalytics: {
    label: 'Google Analytics',
    image: { light: getPartnerLogoUrl('googleanalytics') },
  },
  googlebusinessprofile: {
    label: 'Google Business Profile',
    image: { light: getPartnerLogoUrl('googlebusinessprofile') },
  },
  googlecalendar: {
    label: 'Google Calendar',
    image: { light: getPartnerLogoUrl('googlecalendar') },
  },
  hubspot: { label: 'Hubspot', image: { light: getPartnerLogoUrl('hubspot') } },
  intuitassist: {
    label: 'Intuit Assist',
    image: { light: getBusinessUnitUrl('intuitassist') },
  },
  instagram: {
    label: 'Instagram',
    image: { light: getPartnerLogoUrl('instagram') },
  },
  lightspeed: {
    label: 'Lightspeed',
    image: { light: getPartnerLogoUrl('lightspeed') },
  },
  linkedin: {
    label: 'Linkedin',
    image: { light: getPartnerLogoUrl('linkedin') },
  },
  livechat: {
    label: 'Livechat',
    image: { light: getPartnerLogoUrl('livechat') },
  },
  magento: { label: 'Magento', image: { light: getPartnerLogoUrl('magento') } },
  mailchimp: {
    label: 'Mailchimp',
    image: {
      light:
        'https://digitalasset.intuit.com/render/content/dam/intuit/mc-fe/en_us/logos/logo-freddie-16-light.svg',
      dark: 'https://digitalasset.intuit.com/render/content/dam/intuit/mc-fe/en_us/logos/logo-freddie-16-dark.svg',
    },
  },
  meta: { label: 'Meta', image: { light: getPartnerLogoUrl('meta') } },
  microsoftoffice: {
    label: 'Microsoft Office',
    image: { light: getPartnerLogoUrl('microsoftoffice') },
  },
  miva: { label: 'Miva', image: { light: getPartnerLogoUrl('miva') } },
  nuvemshop: {
    label: 'Nuvemshop',
    image: { light: getPartnerLogoUrl('nuvemshop') },
  },
  opentable: {
    label: 'Opentable',
    image: { light: getPartnerLogoUrl('opentable') },
  },
  paypal: { label: 'PayPal', image: { light: getPartnerLogoUrl('paypal') } },
  photoshop: {
    label: 'Photoshop',
    image: { light: getPartnerLogoUrl('photoshop') },
  },
  pinterest: {
    label: 'Pinterest',
    image: { light: getPartnerLogoUrl('pinterest') },
  },
  prestashop: {
    label: 'PrestaShop',
    image: { light: getPartnerLogoUrl('prestashop') },
  },
  quickbooks: {
    label: 'QuickBooks',
    image: { light: getBusinessUnitUrl('qb') },
  },
  reddit: { label: 'Reddit', image: { light: getPartnerLogoUrl('reddit') } },
  referralcandy: {
    label: 'ReferralCandy',
    image: { light: getPartnerLogoUrl('referralcandy') },
  },
  shopify: { label: 'Shopify', image: { light: getPartnerLogoUrl('shopify') } },
  shopware: {
    label: 'Shopware',
    image: { light: getPartnerLogoUrl('shopware') },
  },
  slack: { label: 'Slack', image: { light: getPartnerLogoUrl('slack') } },
  smileio: {
    label: 'Smile.io',
    image: { light: getPartnerLogoUrl('smileio') },
  },
  snap: { label: 'Snap', image: { light: getPartnerLogoUrl('snap') } },
  square: { label: 'Square', image: { light: getPartnerLogoUrl('square') } },
  squarespace: {
    label: 'Squarespace',
    image: { light: getPartnerLogoUrl('squarespace') },
  },
  stripe: { label: 'Stripe', image: { light: getPartnerLogoUrl('stripe') } },
  threads: { label: 'Threads', image: { light: getPartnerLogoUrl('threads') } },
  toast: { label: 'Toast', image: { light: getPartnerLogoUrl('toast') } },
  tiktok: { label: 'TikTok', image: { light: getPartnerLogoUrl('tiktok') } },
  vimeo: { label: 'Vimeo', image: { light: getPartnerLogoUrl('vimeo') } },
  volusion: {
    label: 'Volusion',
    image: { light: getPartnerLogoUrl('volusion') },
  },
  webflow: { label: 'Webflow', image: { light: getPartnerLogoUrl('webflow') } },
  whatsapp: {
    label: 'WhatsApp',
    image: { light: getPartnerLogoUrl('whatsapp') },
  },
  wistia: { label: 'Wistia', image: { light: getPartnerLogoUrl('wistia') } },
  wix: { label: 'Wix', image: { light: getPartnerLogoUrl('wix') } },
  woocommerce: {
    label: 'WooCommerce',
    image: { light: getPartnerLogoUrl('woocommerce') },
  },
  wordpress: {
    label: 'Wordpress',
    image: { light: getPartnerLogoUrl('wordpress') },
  },
  x: { label: 'X', image: { light: getPartnerLogoUrl('x') } },
  xcart: { label: 'XCart', image: { light: getPartnerLogoUrl('xcart') } },
  yotpo: { label: 'Yotpo', image: { light: getPartnerLogoUrl('yotpo') } },
  youtube: { label: 'YouTube', image: { light: getPartnerLogoUrl('youtube') } },
  zapier: { label: 'Zapier', image: { light: getPartnerLogoUrl('zapier') } },
  zendesk: { label: 'Zendesk', image: { light: getPartnerLogoUrl('zendesk') } },
  triplewhale: {
    label: 'Triple Whale',
    image: { light: getPartnerLogoUrl('triplewhale') },
  },
  asana: { label: 'Asana', image: { light: getPartnerLogoUrl('asana') } },
  bloutout: {
    label: 'Bloutout',
    image: { light: getPartnerLogoUrl('bloutout') },
  },
  blackbaud: {
    label: 'Blackbaud',
    image: { light: getPartnerLogoUrl('blackbaud') },
  },
  classy: { label: 'Classy', image: { light: getPartnerLogoUrl('classy') } },
  mixpanel: {
    label: 'Mixpanel',
    image: { light: getPartnerLogoUrl('mixpanel') },
  },
  monday: { label: 'Monday', image: { light: getPartnerLogoUrl('monday') } },
  patreon: { label: 'Patreon', image: { light: getPartnerLogoUrl('patreon') } },
  googleads: {
    label: 'Google Ads',
    image: { light: getPartnerLogoUrl('googleads') },
  },
  make: { label: 'Make', image: { light: getPartnerLogoUrl('make') } },
  tiendanube: {
    label: 'Tiendanube',
    image: { light: getPartnerLogoUrl('tiendanube') },
  },
  jane: { label: 'Jane', image: { light: getPartnerLogoUrl('jane') } },
  salesforce: {
    label: 'Salesforce',
    image: { light: getPartnerLogoUrl('salesforce') },
  },
  'salesforce-large': {
    label: 'Salesforce',
    image: { light: getPartnerLogoUrl('salesforce-large') },
  },
  mailmunch: {
    label: 'Mailmunch',
    image: { light: getPartnerLogoUrl('mailmunch') },
  },
  salla: { label: 'Salla', image: { light: getPartnerLogoUrl('salla') } },
  'zapier-large': {
    label: 'Zapier',
    image: { light: getPartnerLogoUrl('zapier-large') },
  },
  ifttt: { label: 'IFTTT', image: { light: getPartnerLogoUrl('ifttt') } },
  outfunnel: {
    label: 'Outfunnel',
    image: { light: getPartnerLogoUrl('outfunnel') },
  },
  zohocrm: {
    label: 'Zoho CRM',
    image: { light: getPartnerLogoUrl('zohocrm') },
  },
  gravityforms: {
    label: 'Gravity Forms',
    image: { light: getPartnerLogoUrl('gravityforms') },
  },
};

export const isValidLogo = (key: string) => key in LOGO_MAP;

export const getIntegrationEntryConfig = (integration: string) => {
  return LOGO_MAP[integration];
};
